/* Isolated native-form controller. No cart API, discounts or gift mutations. */
(function (scope) {
  'use strict';
  const PRODUCT = '15347089637680';
  const IDS = Object.freeze({ Green: '67991947346224', Blue: '67991947378992', Red: '67991947411760' });
  function mappedVariant(data, color) {
    if (!data || String(data.productId) !== PRODUCT || data.optionCount !== 1 || data.colorIndex !== 0 || !Array.isArray(data.variants) || data.variants.length !== 3 || !IDS[color]) return null;
    // Validate the entire catalog, not just the currently selected color.
    for (const [name, id] of Object.entries(IDS)) {
      const matches = data.variants.filter(v => v && String(v.id) === id && Array.isArray(v.options) && v.options.length === 1 && v.options[0] === name);
      if (matches.length !== 1) return null;
    }
    return data.variants.find(v => String(v.id) === IDS[color]) || null;
  }
  function quantity(value) {
    const n = Number(value);
    return Number.isSafeInteger(n) && n >= 1 && n <= 99 ? n : null;
  }
  function canPurchase(data, color, qty) {
    const v = mappedVariant(data, color);
    return !!(data && data.enabled === true && data.published === true && data.available === true && data.currency === 'USD' && v && v.available === true && v.price === 2775 && typeof v.image === 'string' && v.image.length && quantity(qty) !== null);
  }
  function money(cents, currency) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', currencyDisplay: 'code' }).format(cents / 100); }
    catch (_) { return 'Price unavailable'; }
  }
  const api = { mappedVariant, quantity, canPurchase, money };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!scope.document) return;
  if (scope.ScreenRetroController) return; // Shared asset may be included by several sections.
  scope.ScreenRetroController = api;
  const instances = new Map();
  function mount(root) {
    if (instances.has(root)) return;
    const cleanup = [];
    const on = (el, name, fn) => {
      el.addEventListener(name, fn);
      cleanup.push(() => el.removeEventListener(name, fn));
    };
    const find = name => root.querySelector('[data-sr-' + name + ']');
    let data;
    try { data = JSON.parse(find('data').textContent); } catch (_) { find('status').textContent = 'Product verification failed. Purchasing is disabled.'; return; }
    const form = root.querySelector('form');
    const radios = Array.from(root.querySelectorAll('[data-sr-color]'));
    const qty = find('quantity'), button = find('submit'), hidden = find('variant'), image = find('image');
    let busy = false;
    let color = 'Green';
    const requested = new URL(scope.location.href).searchParams.get('variant');
    if (requested) color = Object.keys(IDS).find(c => IDS[c] === requested) || '';
    function render() {
      const v = mappedVariant(data, color), q = quantity(qty.value);
      radios.forEach(radio => { radio.checked = radio.value === color; });
      find('color-label').textContent = color ? '— ' + color : '— select a color';
      const validPrice = v && Number.isSafeInteger(v.price) && v.price > 0;
      find('unit').textContent = validPrice ? money(v.price, data.currency) : 'Price unavailable';
      find('total').textContent = validPrice && q ? money(v.price * q, data.currency) : 'Choose a valid quantity';
      const src = v && v.image;
      if (src) { image.src = src; image.alt = 'Translucent ' + color.toLowerCase() + ' ScreenRetro wired USB controller'; image.hidden = false; }
      else { image.removeAttribute('src'); image.hidden = true; }
      find('image-empty').hidden = !!src;
      find('offer-state').textContent = q >= 2 ? '2+ controllers qualifies for one free hub.' : 'Choose 2 or more controllers for the free hub.';
      const allowed = canPurchase(data, color, qty.value);
      hidden.value = v ? String(v.id) : ''; hidden.disabled = !allowed || busy;
      button.disabled = !allowed || busy;
      button.textContent = busy ? 'Opening your cart…' : allowed ? 'Add controller to cart' : 'ADD TO CART · PREVIEW ONLY';
      find('status').textContent = !v ? 'Color mapping could not be verified. Choose a verified color; ordering remains blocked.' : !data.enabled ? 'Preview only — checkout and gift fulfillment are not enabled.' : !allowed ? 'Native product availability, media, USD pricing or quantity is not verified. Ordering is blocked.' : 'One free USB hub is packed with orders containing 2+ controllers, including mixed colors.';
    }
    on(root, 'change', event => {
      if (event.target.matches('[data-sr-color]')) {
        color = event.target.value;
        const v = mappedVariant(data, color);
        if (v) {
          const url = new URL(scope.location.href);
          url.searchParams.set('variant', String(v.id));
          try { scope.history.replaceState({}, '', url); } catch (_) { /* Local file previews may restrict History API. */ }
        }
      }
      render();
    });
    on(qty, 'input', render);
    on(find('minus'), 'click', () => { qty.value = Math.max(1, (quantity(qty.value) || 1) - 1); render(); });
    on(find('plus'), 'click', () => { qty.value = Math.min(99, (quantity(qty.value) || 1) + 1); render(); });
    on(image, 'error', () => { image.hidden = true; find('image-empty').hidden = false; find('image-empty').textContent = 'The native controller photo could not be loaded.'; });
    on(form, 'submit', event => {
      const action = new URL(form.action, scope.location.href);
      if (busy || !canPurchase(data, color, qty.value) || action.origin !== scope.location.origin || !/\/cart\/add\/?$/.test(action.pathname) || form.method.toLowerCase() !== 'post') {
        event.preventDefault(); render(); return;
      }
      // Native POST only. Avoid disabling the successful ID/quantity controls.
      hidden.value = String(mappedVariant(data, color).id);
      hidden.disabled = false;
      busy = true; button.disabled = true; button.textContent = 'Opening your cart…';
      find('status').textContent = 'Opening your cart…';
    });
    on(scope, 'pageshow', () => { busy = false; render(); });
    on(scope, 'popstate', () => { const id = new URL(scope.location.href).searchParams.get('variant'); color = id ? Object.keys(IDS).find(c => IDS[c] === id) || '' : 'Green'; render(); });
    instances.set(root, () => { cleanup.forEach(remove => remove()); instances.delete(root); });
    render();
  }
  function init(parent) { if (parent.matches && parent.matches('[data-sr-controller]')) mount(parent); parent.querySelectorAll('[data-sr-controller]').forEach(mount); }
  if (scope.document.readyState === 'loading') scope.document.addEventListener('DOMContentLoaded', () => init(scope.document), { once: true });
  else init(scope.document);
  scope.document.addEventListener('shopify:section:load', e => init(e.target));
  scope.document.addEventListener('shopify:section:unload', e => { for (const [root, destroy] of instances) if (e.target === root || e.target.contains(root)) destroy(); });
})(typeof window !== 'undefined' ? window : globalThis);
